import styled, { css } from 'styled-components';

import { Breakpoints } from '@powdr/constants';

export const StyledSlider = styled.div`
  position: relative;

  .carousel-control-group {
    justify-content: space-between;

    .slider-control-next, .slider-control-previous {
      .control-arrow-icon {
        margin-left: 20px;

        ${Breakpoints.mobile(css`
          margin-left: 10px;
        `)}
      }
    }
  }
`;
